import { Collapse } from "react-collapse";
import { Row } from "react-grid-system";
import styled from "styled-components";

export const CollapseWrapper = styled(Collapse)`
  padding: 0 30px;

  ${(props) => props.theme.xs`
    padding: 0 15px;
  `}
`;

// The list's own last row. A grid Row like the parcel rows, so it takes their
// gutter margins and spans exactly as wide, with a parcel row's fluid vertical
// padding and bottom divider: the control reads as the tail of the table, not
// a floating button.
export const FooterRow = styled(Row)`
  ${({ theme }) => theme.range("padding-block", "10px", "16px")};
  border-bottom: 1px solid ${({ theme }) => theme.divider};

  ${({ theme }) => theme.xs`
    padding: 15px 0;
  `}
`;

// Its text starts where the sku cell's does (the cell's 10px inset).
export const FooterContent = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: baseline;
  gap: 10px;
  width: 100%;
  padding: 0 10px;
  line-height: 20px;
`;

export const FooterDot = styled.span`
  color: ${({ theme }) => theme.textMuted};
`;

export const FooterCaption = styled.span`
  font-size: 13px;
  color: ${({ theme }) => theme.textMuted};
`;

export const ClickableDiv = styled.div`
  cursor: pointer;
  width: 100%;
`;
